import { render, staticRenderFns } from "./TestBattleShip.vue?vue&type=template&id=6c01c5f0"
import script from "./TestBattleShip.vue?vue&type=script&lang=js"
export * from "./TestBattleShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports